<template>

	<v-footer app :absolute="mxnIsMobileDevice" class="footer white" style="z-index:99">

			<v-row no-gutters>
				<v-col cols="12" :md="mxnIsLessonDataValid ? 'auto' : ''" :sm="mxnIsLessonDataValid ? 6 : 5">
					<v-card-text class="pt-4 text">
						{{ $t("footer.poweredBy") }}
						<img src="@/assets/v2k_bildwortmarke.png" class="logo" alt="logo video2know" />
						<span v-if="this.$root.lessonData.version" class="version">v{{ this.$root.lessonData.version }}</span>
					</v-card-text>
				</v-col>
				<v-col v-if="mxnIsLessonDataValid" cols="12" md="auto" sm="6">
					<v-card-text class="pt-sm-4 ml-md-8 text text-md-left text-sm-right">
						<a href="https://www.video2know.com/versionshinweise" class="mr-4" target="_blank">{{ $t("footer.releaseNotes") }}</a>

						<a v-if="privacyLink" :href="privacyLink" class="mr-4" target="_blank">{{ $t("footer.privacyPolicy") }}</a>
						<a v-else-if="privacyText" class="mr-4" @click="showDlgPrivacyPolicy">{{ $t("footer.privacyPolicy") }}</a>
						<a v-else href="https://www.video2know.com/datenschutz" class="mr-4" target="_blank">{{ $t("footer.privacyPolicy") }}</a>

						<a v-if="legalNoticeLink" :href="legalNoticeLink" class="mr-4" target="_blank">{{ $t("footer.legalNotice") }}</a>
						<a v-else-if="legalNoticeText" class="mr-4" @click="showDlgLegalNotice">{{ $t("footer.legalNotice") }}</a>
						<a v-else href="https://www.video2know.com/impressum" class="mr-4" target="_blank">{{ $t("footer.legalNotice") }}</a>
						<!--
						-->
						<span v-for="(item, i) in links" :key="i" class="px-9">
							<a class="caption" :href="item.link" target="_blank">
								{{ item.text }}
							</a>
						</span>
					</v-card-text>
				</v-col>
				<v-col v-if="!mxnIsMobileDevice" cols="12" md="" :sm="mxnIsLessonDataValid ? 12 : 7">
					<v-card-text :class="mxnIsLessonDataValid ? 'pt-md-4' : 'pt-sm-4'" class="text text-sm-right">
						<div class="pr-1" :class="mxnIsLessonDataValid ? 'd-sm-inline' : 'd-md-inline'">
							{{ $t("footer.questionSupport") }}
						</div>
						<a :href="supportEmailLink" target="_top">
							{{ $t("footer.answerSupport") }}
							<span class="material-icons iconSize18 iconVerticalAlignTextBottom">live_help</span>
						</a>
					</v-card-text>
				</v-col>
			</v-row>

	</v-footer>

</template>

<script>
import Logger from '@/assets/scripts/logger.js'

export default {
	name: "Footer",
	data: () => ({
		//
	}),
	computed: {
		links() {
			var links = [];
			if (process.env.VUE_APP_MODE === "local") {
				links = [
					// { text: 'Eurobase', link: 'https://www.eurobase.lu/unternehmen/webcam/' },
					// { text: 'Video2Know', link: 'https://app.dev.video2know.com' },
					// { text: 'teggee Admin', link: 'https://3admin.dev.teggee.com' },
					{ text: 'video2know Demo', link: 'https://app.dev.video2know.com/?enc=MV0Lr%2FridbOTjg03o1tBJKTAnlRlyBG3m9DvnbevWzbQt6DA%2FQveH9c74glsVpZB' }
				];
			}
			return links;
		},
		legalNoticeLink() {
			return this.$root.lessonData.organisation ? this.$root.lessonData.organisation.legalNoticeLink : null;
		},
		legalNoticeText() {
			return this.$root.lessonData.organisation ? this.$root.lessonData.organisation.legalNoticeText : null;
		},
		privacyLink() {
			return this.$root.lessonData.organisation ? this.$root.lessonData.organisation.privacyStatementLink : null;
		},
		privacyText() {
			return this.$root.lessonData.organisation ? this.$root.lessonData.organisation.privacyStatementText : null;
		},
		supportEmailLink() {
			var email = this.$root.lessonData.organisation ? this.$root.lessonData.organisation.emailSupport : null,
				appName = this.$root.lessonData.organisation ? this.$root.lessonData.organisation.appName : null,
				orgName = this.$root.lessonData.organisation ? this.$root.lessonData.organisation.name : null,
				emailLink = this.$t("footer.supportEmailLink").replace(/ /g, "%20");

			// check values
			email = email || "support@video2know.com";
			appName = encodeURI(appName || "video2know").replace(/\+/g, "%20");
			orgName = encodeURI(orgName || "").replace(/\+/g, "%20");

			return emailLink.format(email, appName, orgName);
		}
	},
	beforeCreate() {
		Logger.log("Footer.vue beforeCreate");
	},
	created() {
		Logger.log("Footer.vue created");
		window.jQuery( window ).on("resize", this.onResize);
	},
	beforeMount() {
		Logger.log("Footer.vue beforeMount");
	},
	mounted() {
		Logger.log("Footer.vue mounted");
	},
	beforeUpdate() {
		Logger.log("Footer.vue beforeUpdate");
	},
	updated() {
		Logger.log("Footer.vue updated");
	},
	beforeDestroy() {
		Logger.log("Footer.vue beforeDestroy");
		window.jQuery( window ).off("resize", this.onResize);
	},
	destroyed() {
		Logger.log("Footer.vue destroyed");
	},
	methods: {
		onResize() {
			var footerHeight = this.$el.clientHeight,
				footerPadding = parseInt(window.jQuery("main").css("padding-bottom"));
			
			// adjust bottom of main content when the footer height changes, due to responsive adaptations of the layout
			if (footerPadding != footerHeight) {
				window.jQuery("main").css("padding-bottom", footerHeight);
			}
		},
		showDlgLegalNotice() {
			this.$root.modalDialog.title = "modalDialog.legalNoticeTitle"; // from json locale file
			this.$root.modalDialog.content = this.legalNoticeText;
			this.$root.modalDialog.showDialog = true;
		},
		showDlgPrivacyPolicy() {
			this.$root.modalDialog.title = "modalDialog.privacyStatementTitle"; // from json locale file
			this.$root.modalDialog.content = this.privacyText;
			this.$root.modalDialog.showDialog = true;
		}
	}
}
</script>

<style lang="scss" scoped>

	@import '@/assets/scss/_definitions.scss';
	
	.footer {
		border-top: 1px solid $globColQuint;
		
		a {
			color: $globColPrim;
			text-decoration: none;
		}

		.text {
			font-size: 0.75rem;
			font-weight: 400;
			line-height: 1.1875rem;
			padding: 0;
		}

		.logo {
			height: 1.125rem;
			vertical-align: middle;
			margin-left: 0.5rem;
		}

		.version {
			margin-left: 0.2rem;
			font-size: 0.625rem;
		}
	}

</style>
